import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const baseurl =
    process.env.REACT_APP_BASE_URL ||
    "http://localhost:8000/api";

const handleError = (error) =>
    error?.response?.data || { detail: error?.message || "Request failed." };

export const fetchLearningHubCategories = createAsyncThunk(
    "learningHub/fetchCategories",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${baseurl}/learning-hub/categories/`);
            return response.data;
        } catch (error) {
            return rejectWithValue(handleError(error));
        }
    }
);

export const fetchLearningHubFeatured = createAsyncThunk(
    "learningHub/fetchFeatured",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${baseurl}/learning-hub/featured/`);
            return response.data;
        } catch (error) {
            return rejectWithValue(handleError(error));
        }
    }
);

export const fetchLearningHubArticles = createAsyncThunk(
    "learningHub/fetchArticles",
    async (params = {}, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${baseurl}/learning-hub/articles/`, { params });
            return response.data;
        } catch (error) {
            return rejectWithValue(handleError(error));
        }
    }
);

export const fetchLearningHubArticle = createAsyncThunk(
    "learningHub/fetchArticle",
    async (slug, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${baseurl}/learning-hub/articles/${slug}/`);
            return response.data;
        } catch (error) {
            return rejectWithValue(handleError(error));
        }
    }
);
